// extracted by mini-css-extract-plugin
export default {"outerWrapper":"_3MeQN___NotFound-module__outerWrapper","wrapper":"_1B9_J___NotFound-module__wrapper"};